<template>
  <div class="page">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout'
}
</script>

<style lang="scss" scoped>
  .page {
    height: 100%;
    width: 100%;
  }
</style>